/**
 * createSplitQueryFromTargetSource
 *
 * Builds the `SplitQuery` that scopes one target's document in a per-target send
 * (SYD-2302), straight from the workflow's own `tableColumn` target source: the
 * AR table the targets come from and the column that names each one. Its consumer
 * is `WorkflowParameterContent`, for the Preview PDF and for the fan-out loop in
 * `handleOk`.
 *
 * Deliberately independent of the form type's `splitConfiguration`. A workflow
 * that fans out on a column no split criterion declares is the shipped shape on
 * CLW, and matching the two is what left every target unpreviewable and every run
 * refused (SYD-2412). `resolveSplitForTable` reads only `valuePath` and
 * `queryValue`, so a query built here scopes exactly as a declared criterion does.
 *
 * `description` is empty because nothing reads it. `resolveSplitForTable` takes
 * only `valuePath` and `queryValue` off `splitRef`, and no caller hands a
 * `SplitQuery.splitRef` to `resolveSplitLabel` — the labels an operator sees come
 * from the target's own option, never from here.
 */

import type { SplitQuery, WorkflowTargetSource } from '#types';

type TableColumnTargetSource = Extract<WorkflowTargetSource, { sourceType: 'tableColumn' }>;

export const createSplitQueryFromTargetSource = (params: {
    targetSource: Pick<TableColumnTargetSource, 'tableId' | 'columnId'>;
    targetId: string;
}): SplitQuery => ({
    splitRef: {
        fieldId: params.targetSource.tableId,
        valuePath: params.targetSource.columnId,
        description: {},
    },
    queryValue: params.targetId,
    mode: 'include',
});
